import { FPsendLink } from "../../components";
import './ForgotPasswordSL.css'

const ForgotPasswordSL = ()=>{
    return (
        <div className="fpsl-page">
            <FPsendLink/>
        </div>
    )
};

export default ForgotPasswordSL;